export default __webpack_public_path__ + "static/media/avatar.30b37bbd.jpg";